import { render } from "./PageDataTransaksiPembayaran.vue?vue&type=template&id=c152adce"
import script from "./PageDataTransaksiPembayaran.vue?vue&type=script&lang=js"
export * from "./PageDataTransaksiPembayaran.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__